export enum PanelValue {
  AGGREGATED_INDICATORS,
  PORTFOLIO_INDICATORS,
  PROJECT_INDICATORS,
  SUPPORT_INDICATORS,
}
